/**
 * Footer Module - Utilities
 */

/**
 * Translates newsletter error messages to Romanian
 *
 * @param error - Error message from API (English)
 * @returns Translated error message (Romanian) or original if no translation exists
 */
export function getNewsletterErrorMessage(error: string | null): string | null {
  if (!error) return null

  // Translation map for common newsletter errors
  const errorTranslations: Record<string, string> = {
    'You must specify an email address to subscribe to a newsletter.':
      'Trebuie să introduci o adresă de email pentru a te abona.',
    'This email address is already subscribed.':
      'Această adresă de email este deja abonată.',
    'Please enter a valid email address.':
      'Te rugăm să introduci o adresă de email validă.',
  }

  return errorTranslations[error] || error
}
